//import useReservationService  from "./useReservationService";
import Capsule from 'layout/Capsule';

//Components
import { IoChevronForward, IoFlash, IoInformationCircle, IoPricetag, IoSparklesSharp, IoTime } from 'react-icons/io5';

//Logic
import useReservationService from './useReservationService';
import { useAuthValue } from 'context/AuthContext';
import OffcanvasServiceInfo from 'components/offcanvas/OffCanvasProductServiceInfo';
import { numb } from 'utils/helpers';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


function ServiceItemChild({
    product,
    selectProduct,
    showProductDetail
}) {
    return (
        <div className='lh-base mt-1 text-14 d-flex justify-content-between'>
            <span>
                <label className="lh-16" style={{ color: '#dadada' }} htmlFor={`radio_${product.id}`}>
                    <div className="form-switch d-inline p-0">
                        <input
                            type="checkbox"
                            className="form-check-input float-none m-0 me-1 d-inline-block align-middle"
                            name="mainServiceList_child"
                            checked={!!product?.is_selected}
                            id={`radio_${product?.id}`}
                            onChange={() => selectProduct(product)}
                        />
                    </div>
                    {product.description}

                    {!!product.time && (
                        <div className="service-time" style={{ marginLeft: '34px', marginTop: '3px' }}>
                            <IoTime className='vertical-align-n2' />{product.time} minuti
                        </div>
                    )}

                </label>
            </span>

            <span className="d-inline-block active text-14 text-end align-self-baseline nowrap" style={{ minWidth: '55px' }}>
                {product.description_extend && <IoInformationCircle
                    className={`info-icon ${product?.price ? 'float-start' : ''}`}
                    onClick={() => showProductDetail(product.id)}
                />}
                {product?.price ? `${product?.price}€` : ''}
            </span>


        </div>
    );
}

function PackageCard({ pkg, products, isRecommended, onSelect }) {

    const includedProducts = (pkg.items || []).map(it => products?.find(p => p.id === it.product_id)).filter(Boolean);

    if (includedProducts.length === 0) return null;

    const hasPriority = !!pkg.priority_active;
    const priorityPrice = hasPriority ? includedProducts.reduce((sum, p) => sum + (p.priority_price || 0), 0) : 0;


    const total = includedProducts.reduce((sum, p) => sum + (p.price || 0), 0) + priorityPrice;

    const pkgIds = new Set(includedProducts.map(p => p.id));
    includedProducts.forEach(p => { if (p.parent_id) pkgIds.add(p.parent_id); });
    const selectedIds = (products || []).filter(p => p.is_selected).map(p => p.id);
    const priorityEligibleProducts = includedProducts.filter(p => p.priority_active);
    const hasPrioritySelection = priorityEligibleProducts.some(p => p.is_priority);
    const isPriorityMatch = pkg.priority_active
        ? priorityEligibleProducts.every(p => p.is_priority)
        : !hasPrioritySelection;
    const isApplied = selectedIds.length === pkgIds.size && selectedIds.every(id => pkgIds.has(id)) && isPriorityMatch;

    return (
        <div  style={{ position: 'relative', width: '100%', minWidth: 0 }}>
            {isRecommended && (
                <span
                    className="rounded-pill px-3 py-05 text-11 fw-600 text-white bg-primary"
                    style={{
                        position: 'absolute',
                        top: '-12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                        zIndex: 2
                    }}
                >
                    CONSIGLIATO
                </span>
            )}
            <div
                className={`wide-block p-2 rounded mb-1 cursor-pointer h-200 ${(isApplied) ? 'border border-primary border-3' : ''}`}
                style={{ width: '100%', minWidth: 0, height: '230px', maxHeight: '250px', minHeight: '170px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}
                onClick={() => onSelect(pkg)}
            >
            <div className="d-flex justify-content-between align-items-center text-capitalize fs-5">
                <span className="text-white fw-600">{pkg.description}</span>
            </div>
             {pkg.description_extend && (
                <div className="text-40 mt-05 " style={{ color: '#939393' }}>{pkg.description_extend}</div>
            )}

            <div className="mt-1">
                <span className="text-20 nowrap" style={{ minWidth: '55px' , color: '#fff', fontWeight: '600'}}>
                    {total ? `${total}€` : ''}
                </span>
            </div>

            <div
                className="text-12 mt-05 mb-0"
                
            >
                {includedProducts.map(p => (
                    <div key={p.id} className="d-flex align-items-start gap-1">
                        <span className="text-primary">•</span>
                        <span style={{ color: '#bdbdbd' }}>{p.description}</span>
                        {(p.priority_active && hasPriority) && (
                            <span className="ms-1 rounded-pill px-1 text-white bg-primary" style={{ lineHeight: 2, fontSize: '11px' }} >
                                consegna in 24h
                            </span>
                        )}
                    </div>
                ))}
            </div>

            </div>
        </div>
    );
}

function ServiceItem(props) {
    const {
        product,
        products,
        isSkeleton,
        selectProduct = () => { },
        selectProductPriority = () => { },
        showProductDetail,
        disabled = false
    } = props;

    const isContainerProduct = product?.price === null;
    const hasChildSelected = products && products.some(p => p.parent_id === product.id && p.is_selected);

    return (
        <div className="form-check">
            <input
                type={product?.type === 'PRIMARY' ? 'radio' : 'checkbox'}
                className="form-check-input"
                name="mainServiceList"
                checked={!!product?.is_selected}
                id={`radio_${product?.id}`}
                onChange={() => selectProduct(product)}
                disabled={disabled}
            />
            <label className="form-check-label" htmlFor={`radio_${product?.id}`} >
                <div className="flex-fill">
                    <div className="service-title service-title d-flex justify-content-between">
                        {isSkeleton && <span className='placeholder' style={{ width: '200px' }} />}
                        <span>
                            <div className="d-flex align-items-center gap-1">
                                {product?.description}
                                {product?.is_new && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id={`org-new-tooltip-${product?.id || 'new'}`}>NEW</Tooltip>}
                                        >
                                        <span
                                            className="badge badge-primary badge-empty mb-1"
                                            style={{
                                                border: '2px solid #fff',
                                                boxSizing: 'content-box'
                                            }}
                                        />
                                    </OverlayTrigger>
                                )}
                            </div>
                            {isContainerProduct && product.is_selected && (
                                <><br /><span className={`text-12 ${hasChildSelected ? '' : 'text-warning'}`} style={{ color: '#939393' }}>Seleziona la tipologia*</span></>
                            )}
                        </span>
                        {isSkeleton ?
                            <span className='placeholder' style={{ width: '50px' }} /> : <>
                                <span className="d-inline-block active text-14 text-end align-self-baseline nowrap" style={{ minWidth: '55px' }}>
                                    {product.description_extend && <IoInformationCircle
                                        className={`info-icon ${product?.price ? 'float-start' : ''}`}
                                        onClick={() => showProductDetail(product.id)}
                                    />}
                                    {product?.price ? `${product?.price}€` : ''}
                                </span>
                            </>}

                    </div>
                    {!!product?.time && <div className={`service-time ${isSkeleton ? 'placeholder' : ''}`}>
                        <IoTime className='vertical-align-n2' />
                        {product?.time} minuti
                    </div>}
                    {product && product.is_selected && products && products.filter(p => p.parent_id === product.id).map(child_product => (
                        <ServiceItemChild
                            key={child_product.id}
                            product={child_product}
                            selectProduct={selectProduct}
                            showProductDetail={showProductDetail}
                        />
                    ))}
                    {product?.priority_active && product?.is_selected ?
                        <div className='lh-base mt-1 text-14 d-flex justify-content-between'>
                            <span>
                                <label className="lh-16" style={{ color: '#dadada' }} htmlFor={`priority_${product.id}`}>
                                    <div className="form-switch d-inline p-0">
                                        <input
                                            id={`priority_${product.id}`}
                                            type="checkbox"
                                            className="form-check-input float-none m-0 me-1 d-inline-block align-middle"
                                            checked={!!product.is_priority}
                                            onChange={() => selectProductPriority(product)}
                                            disabled={disabled}
                                        />
                                    </div>
                                    {product.priority_label}
                                </label>
                            </span>
                            <span className='active'>
                                {product.priority_price}€
                            </span>
                        </div>
                        : ''}
                </div>
            </label>
        </div>
    );
}

export default function ReservationService(props) {

    const {
        products,
        packages,
        handleSelectProduct, handleSelectProductPriority,
        handleSelectPackage,
        selectedProducts,
        cartItems,
        nextStep,
        buildingData,
        photographers
    } = props;

    const {
        showOffCanvasServiceInfo, setShowOffCanvasServiceInfo,
        handleProductDetail
    } = useReservationService();

    const subscription = buildingData?.organization?.subscription;;

    return (
        <>
            <Capsule className='extra-header-active pb-1 with-bottom-menu placeholder-glow'>
                {subscription && subscription.discount_percentage > 0 && 
                    <div className='mt-2 text-center alert text-white mx-3 lh-sm bg-amazon py-2'>
                        <span className='opacity-75'><IoSparklesSharp /> Avendo acquistato una ricarica <b>{subscription.description}</b> hai diritto ad un <b>{subscription.discount_percentage}% di sconto</b> su tutti i servizi elencati di seguito, che verrà applicato sul totale. <IoSparklesSharp /></span>
                    </div>
                }
                {products && packages && packages.length > 0 && (
                    <div className="section f mt-2 d-flex flex-column me-05">
                        <h4 className="card-subtitle text-primary me-05 text-12 d-flex align-items-center px-2">
                            <IoSparklesSharp className='me-05' />
                            Pacchetti consigliati:
                        </h4>

                        <div className="d-flex gap-4 flex-column">
                            <div className="px-2 gap-1 d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-center fs-5">
                                    <span className="text-white fw-600">Scegli il pacchetto più adatto a questo immobile</span>
                                </div>
                                <div className="text-40" style={{ color: '#939393', lineHeight: 1.2 }}>Soluzioni pensate per valutare al meglio ogni tipo di immobile</div>
                            </div>
                            
                            <div
                                className="packages-grid"
                                style={{ '--pkg-count': packages.length }}
                            >
                                {packages.map((pkg, index) => (
                                    <PackageCard
                                        key={index}
                                        pkg={pkg}
                                        products={products}
                                        isRecommended={index === Math.floor(packages.length / 2)}
                                        onSelect={handleSelectPackage}
                                        selectProductPriority={handleSelectProductPriority}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                <div className="section section-full-mobile mt-2">
                    <h4 className="card-subtitle text-white pt-1 text-12">Seleziona servizio principale:</h4>
                    <div className="wide-block p-0 rounded">
                        <div className="input-list service-items">
                            {(!products || !photographers) && Array(2).fill(null).map((_, i) => <ServiceItem key={i} isSkeleton />)}
                            {products && photographers && products.filter(p => p.type === 'PRIMARY' && !p.parent_id).map(product => (
                                <ServiceItem
                                    key={product.id}
                                    product={product}
                                    products={products}
                                    selectProduct={handleSelectProduct}
                                    selectProductPriority={handleSelectProductPriority}
                                    showProductDetail={handleProductDetail}
                                />)
                            )}
                        </div>
                    </div>
                </div>
                    <div className="section section-full-mobile mt-3 mb-1 ">
                        <h4 className="card-subtitle text-white text-12">Seleziona servizi extra:</h4>
                        <div className="wide-block p-0 rounded">
                            <div className="input-list service-items">
                                {products && products.filter(p => p.type === 'EXTRA' && !p.parent_id).map(product => (
                                    <ServiceItem
                                        disabled={!products.some((p) => p.type === 'PRIMARY' && !p.parent_id && p.is_selected)}
                                        key={product.id}
                                        product={product}
                                        products={products}
                                        selectProduct={handleSelectProduct}
                                        selectProductPriority={handleSelectProductPriority}
                                        selectedProducts={selectedProducts}
                                        showProductDetail={handleProductDetail}
                                    />)
                                )}
                            </div>
                        </div>
                    </div>
            </Capsule>
            <OffcanvasServiceInfo
                product={showOffCanvasServiceInfo}
                handleClose={() => setShowOffCanvasServiceInfo()}
            />
        </>);
}
